if (!customElements.get('q-review-carousel')) {
  customElements.define('q-review-carousel', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.q2-reviews');
      this.cards = [...this.querySelectorAll('.q2-review')];
      if (!this.track || !this.cards.length) return;
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.previous = this.querySelector('[data-review-prev]');
      this.next = this.querySelector('[data-review-next]');
      this.position = this.querySelector('.q2-review-position');
      this.controls = this.querySelector('.q2-review-controls');
      this.previous.addEventListener('click', () => this.move(-1), options);
      this.next.addEventListener('click', () => this.move(1), options);
      this.track.addEventListener('scroll', () => this.update(), { ...options, passive: true });
      this.track.addEventListener('keydown', (event) => {
        if (event.target !== this.track) return;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          this.move((event.key === 'ArrowLeft') === this.rtl ? 1 : -1);
        } else if (event.key === 'Home' || event.key === 'End') {
          event.preventDefault();
          this.go(event.key === 'Home' ? 0 : this.max);
        }
      }, options);
      this.addEventListener('shopify:block:select', (event) => {
        const card = event.target.closest('.q2-review');
        const index = this.cards.indexOf(card);
        if (index >= 0) this.go(index * this.step);
      }, options);
      this.observer = new ResizeObserver(() => this.update());
      this.observer.observe(this.track);
      this.update();
    }

    update() {
      const style = getComputedStyle(this.track);
      this.rtl = style.direction === 'rtl';
      this.step = this.cards[0].getBoundingClientRect().width + (parseFloat(style.columnGap) || 0);
      this.max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      const offset = Math.min(this.max, Math.abs(this.track.scrollLeft));
      this.previous.disabled = offset < 2;
      this.next.disabled = offset >= this.max - 2;
      this.controls.hidden = this.max < 2;
      const first = Math.min(this.cards.length, Math.round(offset / this.step) + 1);
      const visible = Math.max(1, Math.round((this.track.clientWidth + (parseFloat(style.columnGap) || 0)) / this.step));
      const last = Math.min(this.cards.length, first + visible - 1);
      const label = `${first === last ? first : `${first}–${last}`} / ${this.cards.length}`;
      if (this.position.textContent !== label) this.position.textContent = label;
    }

    move(direction) {
      this.go(Math.round(Math.abs(this.track.scrollLeft) / this.step) * this.step + direction * this.step);
    }

    go(offset) {
      const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.track.scrollTo({ left: Math.max(0, Math.min(offset, this.max)) * (this.rtl ? -1 : 1), behavior: reduced ? 'instant' : 'smooth' });
    }

    disconnectedCallback() {
      this.events?.abort();
      this.observer?.disconnect();
    }
  });
}
